import { getBackgroundColorStyle as _, getBackgroundImageStyle as y } from "@typedream/core";
import d from "classnames";
import { useRef as N, useEffect as I, isValidElement as E } from "react";
import { rootElement as R, alignLeft as S, alignCenter as V, alignRight as x, alignTop as B, alignMiddle as $, alignBottom as j, verticalSnapScroll as C, background as s, backgroundVideo as D } from "./Root.css.js";
import { jsxs as H, jsx as r } from "react/jsx-runtime";
function w(m) {
  const {
    element: t,
    children: u,
    className: k,
    style: f,
    attributes: p,
    backgroundImageElement: b
  } = m, {
    align: l,
    vertical_align: a,
    background: v,
    backgroundDarken: i,
    backgroundVideo: o,
    vertical_snap_scroll: h,
    customAttributes: n
  } = t, e = b || t.backgroundImage, c = N(null);
  return I(() => {
    var g;
    (g = c.current) == null || g.load();
  }, [o]), /* @__PURE__ */ H("div", {
    ...n,
    className: d(k, R, {
      [S]: l === "align_left",
      [V]: l === "align_center",
      [x]: l === "align_right",
      [B]: a === "align_start",
      [$]: a === "align_center",
      [j]: a === "align_end",
      [C]: !!h
    }, n == null ? void 0 : n.className),
    style: {
      ..._(v),
      ...typeof e == "string" && {
        backgroundImage: `url("${e}")`,
        ...y(e, i)
      },
      minHeight: a ? "100vh" : void 0,
      ...f
    },
    ...p,
    children: [E(e) && /* @__PURE__ */ r("div", {
      className: s,
      children: e
    }), o && /* @__PURE__ */ r("div", {
      className: s,
      children: /* @__PURE__ */ r("video", {
        ref: c,
        className: d(D, {
          darken: i
        }),
        autoPlay: !0,
        muted: !0,
        loop: !0,
        playsInline: !0,
        children: /* @__PURE__ */ r("source", {
          src: o
        })
      })
    }), u]
  });
}
export {
  w as RootElement
};
